// GENERATED from ez-tree preset "Bush 1" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const Bush1_KIND_ID = "ezTree_Bush1";

export const Bush1Kind = new SceneryKindDef({
	id: "ezTree_Bush1",
	name: "Bush 1",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchAngle1": 21.521739130434785,
		"branchAngle2": 62.608695652173914,
		"branchChildren1": 3,
		"branchChildren2": 2,
		"branchGnarliness0": 0.11,
		"branchGnarliness1": 0.09,
		"branchGnarliness2": 0.05,
		"branchGnarliness3": 0.09,
		"branchLength0": 0.1,
		"branchLength1": 15.302173913043479,
		"branchLength2": 5.59,
		"branchLength3": 4.6,
		"branchRadius0": 0.5793478260869566,
		"branchRadius1": 0.9521739130434783,
		"branchRadius2": 0.76,
		"branchSections0": 6,
		"branchSections1": 6,
		"branchSections2": 10,
		"branchSections3": 10,
		"branchSegments0": 4,
		"branchSegments1": 4,
		"branchStart1": 0.53,
		"branchStart2": 0.33,
		"branchStart3": 0,
		"branchTwist0": 0.3,
		"branchTwist1": -0.07,
		"leafCount": 12,
		"leafSize": 2.4456521739130435,
		"leafSizeVariance": 0.717,
		"leafAngle": 55,
		"leafType": "ash",
		"barkTint": 13552830,
		"barkTextureScaleX": 0.5,
		"barkTextureScaleY": 5,
		"forceStrength": 0,
		"targetHeight": 6.7 * 0.3,
	},
	footprintRadiusRatio: 0.727,
});
